import { render, staticRenderFns } from "./partner.vue?vue&type=template&id=50677b4e&scoped=true"
import script from "./partner.vue?vue&type=script&lang=js"
export * from "./partner.vue?vue&type=script&lang=js"
import style0 from "./partner.vue?vue&type=style&index=0&id=50677b4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50677b4e",
  null
  
)

export default component.exports